import { useAuth as useAuthContext } from '../contexts/AuthContext'
import { useEffect, useRef } from 'react'

// 기존 useAuth의 기능을 AuthContext로 옮겼으므로, 단순히 새 context를 반환
export function useAuth() {
  const auth = useAuthContext()
  const prevUserRef = useRef<typeof auth.user>(null)
  const isFirstRender = useRef(true)
  
  // 디버깅: 사용자가 null이 되는 경우를 추적 (상태 변경 시에만 로깅)
  useEffect(() => {
    // 첫 렌더링 또는 사용자 상태가 변경된 경우에만 로깅
    if (isFirstRender.current || prevUserRef.current !== auth.user) {
      isFirstRender.current = false
      prevUserRef.current = auth.user
      
      // if (auth.user === null) {
      //   console.log('⚠️ useAuth - 사용자가 null입니다:', {
      //     time: new Date().toISOString(),
      //     url: window.location.href,
      //     stackTrace: new Error().stack
      //   })
      // } else if (auth.user) {
      //   console.log('✅ useAuth - 사용자 정보 있음:', {
      //     userId: auth.user.id,
      //     time: new Date().toISOString()
      //   })
      // }
    }
  }, [auth.user])
  
  return auth
}
